// Shared workflow status constants — keep in sync with the backend orchestrator
// (FWAPI: fieldworker/helpers/workflows.js)

// Workflow definition status (wf_status)
export const WF_STATUS = {
    DRAFT: 0,
    PUBLISHED: 1,
};

// Workflow instance status (wf_instanceStatus)
export const INSTANCE_STATUS = {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    PAUSED: 3,
    CLOSED: 4,
    BLOCKED: 5,
};

export const INSTANCE_STATUS_LABELS = {
    [INSTANCE_STATUS.NOT_STARTED]: 'Not Started',
    [INSTANCE_STATUS.IN_PROGRESS]: 'In Progress',
    [INSTANCE_STATUS.COMPLETED]: 'Completed',
    [INSTANCE_STATUS.PAUSED]: 'Paused',
    [INSTANCE_STATUS.CLOSED]: 'Closed',
    [INSTANCE_STATUS.BLOCKED]: 'Blocked',
};

// Edge lifecycle status (edge_status)
export const EDGE_STATUS = {
    COMPLETED: 0,
    ACTIVE: 1,
    BLOCKED: 2,
};

// Instances in these states can no longer be modified
export const READONLY_INSTANCE_STATUSES = [INSTANCE_STATUS.COMPLETED, INSTANCE_STATUS.CLOSED];
